import {makeAutoObservable} from 'mobx'

export default class Dashboard {
  institutionId: number

  allCount?: number

  payAllCount?: number

  rejectCount?: number

  duplicateCount?: number

  payAmount?: number

  payMonth?: string

  prevDifferences?: number

  constructor(dashboard: any) {
    this.institutionId = dashboard.InstitutionId
    this.allCount = dashboard.AllCount
    this.payAllCount = dashboard.PayAllCount
    this.rejectCount = dashboard.RejectCount
    this.duplicateCount = dashboard.DuplicateCount
    this.payAmount = dashboard.PayAmount
    this.payMonth = dashboard.PayMonth
    this.prevDifferences = dashboard.PrevDifferences

    makeAutoObservable(this)
  }
}
